<template>
  <div class="KYCMainVisualContent">
    <div class="KYCMainVisualContent__shadow">
      <div class="KYCMainVisualContent__focus show-animation">
        <img
          class="KYCMainVisualContent__card show-animation card-delay"
          width="210px"
          src="~@/assets/img/kyc_info/img_kyc_id_card.png"
        />

        <img
          class="KYCMainVisualContent__sheild show-animation shiled-delay"
          width="111px"
          src="~@/assets/img/kyc_info/img_kyc_sheild.png"
        />

        <img
          class="KYCMainVisualContent__checked show-animation checked-delay"
          width="56px"
          src="~@/assets/img/kyc_info/img_kyc_checked.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "KYCMainVisualContent",
};
</script>
<style lang="scss" scoped>
.KYCMainVisualContent {
  margin: 10px auto 0 auto;
  background: url("~@/assets/img/kyc_info/img_kyc_background.png") no-repeat
    left top / contain;
  width: 328px;
  height: 196px;
  position: relative;

  &__shadow {
    margin: 0 auto;
    padding-top: 10px;
    width: 328px;
    height: 196px;
    background: url("~@/assets/img/kyc_info/img_kyc_shadow.png") no-repeat left
      top / contain;
  }

  &__focus {
    margin: 0 auto;
    background: url("~@/assets/img/kyc_info/img_kyc_focus.png") no-repeat center
      center / contain;
    width: 243px;
    height: 163px;
    position: relative;
  }

  &__card {
    margin-left: 25px;
    margin-top: 10px;
  }

  &__sheild {
    position: absolute;
    left: -11px;
    top: 41px;
  }

  &__checked {
    position: absolute;
    right: 7px;
    bottom: 19px;
  }

  .show-animation {
    animation-duration: 1s;
    animation-name: focus;
    -webkit-animation-duration: 1s;
    -webkit-animation-name: focus;
    animation-fill-mode: forwards;
    transform: scale(0);
  }

  .card-delay {
    animation-delay: 0.4s;
  }

  .shiled-delay {
    animation-delay: 0.6s;
  }

  .checked-delay {
    animation-delay: 0.8s;
  }

  @keyframes focus {
    from {
      transform: scale(0);
    }

    to {
      transform: scale(1);
    }
  }
}
</style>
